define('../../widgets/logo/main',[
  'jquery',
  'settings',
  'utils/translate',
  'utils/toast',
  'modules/alert-box',
  'modules/magnify-image-box',
  'server-settings',
  'modules/overlay-box'
], function ($, settings, t, toast, AlertBox, MagnifyImageBox, serverSettings, OverlayBox) {
  'use strict';

  return function () {
    function Logo() {
      this.BindActions();
      this.LogoListingBindFocus();
    }

    Logo.prototype.BindActions = function () {
      var _this = this;

      $('body').on('click', '.logo [data-action]', function (e) {
        var currentTarget = $(e.currentTarget),
          logoID = currentTarget.closest('[data-logo-id]').data('logo-id'),
          btnAction = currentTarget.data('action');

        switch (btnAction) {
          case 'download':
            e.preventDefault();
            _this.downloadLogo(logoID);
            break;
          case 'delete':
            e.preventDefault();
            _this.deleteLogo(logoID, currentTarget.attr('href'));
            break;
          case 'open':
            e.preventDefault();
            _this.openLogo(logoID);
            break;
        }
      });

      $('body').on('click', '.folder-container [data-action]', function (e) {
        e.preventDefault();

        var currentTarget = $(e.currentTarget),
          folderID = currentTarget.closest('[data-folder-id]').data('folder-id'),
          action = currentTarget.data('action');

        switch (action) {
          case 'openFolder':
            _this.openFolder(folderID);
            break;
          case 'delete':
            _this.deleteFolder(folderID);
            break;
          case 'closeFolder':
            _this.closeFolder();
            break;
        }
      });

      $('#back-button').click(function (event) {
        event.preventDefault();
        _this.closeFolder();
      });

      $('body').on('click', '.popupFolder', function (e) {
        var name = 'None';
        var target = $(e.currentTarget);
        if (target.hasClass('selected')) {
          target.toggleClass('selected');
          _this.currentSelected = null;
        } else {
          if (_this.currentSelected) {
            _this.currentSelected.toggleClass('selected');
          }
          _this.currentSelected = $(e.currentTarget);
          _this.currentSelected.toggleClass('selected');
          name = _this.currentSelected.children('.folder-name').html();
        }
        $('#popup-selected-text').html(name);
      });

      $('#logo-listing-container').on('openFolder', function (e, folderID) {
        e.preventDefault();
        _this.openFolder(folderID);
      });

      $('#btnCreateFolder').click(function (event) {
        event.preventDefault();
        var name = $('#name').val();
        _this.createFolder(name);
      });

      $('#testingPopup').click(function (event) {
        event.preventDefault();
        $('#logo-listing-container').trigger('openFolderPopup');
      });

      $('#logo-listing-container').on('closeFolderPopup', function (event) {
        _this.ob.destroy();
      });

      $('#logo-listing-container').on('openFolderPopup', function (event) {
        //event.preventDefault();
        _this.currentSelected = null;

        _this.ob = new OverlayBox($('#popup-folder-container-template'), {});
        _this.ob.setup();
        _this.ob.load(function () {
          _this.ob.show();
        });

        $.ajax({
          method: 'GET',
          url: serverSettings.imageFolderApi,
          success: function (data) {
            var popupContainer = $('#popup-folder-container');
            if (popupContainer) {
              for (var i = 0; i < data.length; i++) {
                popupContainer.trigger('add', data[i]);
              }
            }
          }
        });

        _this.ob.addDestroyCallback(function () {
          $('#logo-listing-container').trigger('save-logo-images-abort');
        });

        _this.BindEventsSavePopup();
      });

      $('#logo-listing-container').on('loadFolder', function (event, folderID) {
        _this.loadFolder(folderID);
      });

      $('#logo-listing-container').on('saveApplication', function (event, appInfo) {
        $('#logo-listing-container').trigger('save-logo-images', appInfo);
      });
    };

    Logo.prototype.LogoListingBindFocus = function () {
      $('body').on('mouseenter', '.logo__image', function () {
        $(this).closest('.logo').addClass('logo--focused');
      });
      $('body').on('mouseleave', '.logo__image', function () {
        $(this).closest('.logo').removeClass('logo--focused');
      });
    };

    Logo.prototype.BindEventsSavePopup = function () {
      var _this = this;
      $('#popupSaveBtn').click(function (event) {
        event.preventDefault();
        var folderId = '';
        if (_this.currentSelected) {
          folderId = _this.currentSelected.data('folder-id');
        }
        $('#logo-listing-container').trigger('save-logo-images', { folderId: folderId });
        $('#logo-listing-container').trigger('closeFolderPopup');
      });

      $('#popupCloseBtn').click(function (event) {
        event.preventDefault();
        $('#logo-listing-container').trigger('closeFolderPopup');
        $('#logo-listing-container').trigger('save-logo-images-abort');
      });

      $('#btnCreateFolderPopup').click(function (e) {
        e.preventDefault();
        var name = $('#namePopup').val();
        _this.createFolder(name);
      });
    };

    Logo.prototype.createFolder = function (name) {
      $.ajax({
        method: 'POST',
        url: serverSettings.imageFolderApi,
        data: { name: name },
        success: function (data) {
          data.isFolder = true;
          $('[data-view="LogoListing"]').trigger('add', data);
        }
      });
    };

    Logo.prototype.openFolder = function (folderID) {
      this.closeFolder();
      $('#main-listing').css('display', 'none');
      $('#folder-' + folderID).css('display', '');
      $('#folder-container-' + folderID).addClass('selected');
      $('#folder-container-root').data('folder-id', folderID);
    };

    Logo.prototype.closeFolder = function () {
      var folderID = $('#folder-container-root').data('folder-id');
      $('#folder-container-' + folderID).removeClass('selected');
      $('#main-listing').css('display', '');
      $('#folder-' + folderID).css('display', 'none');
    };

    Logo.prototype.deleteFolder = function (folderID, _this) {
      var url = serverSettings.imageFolderApiDelete.replace(':id', folderID);
      var name = '#folder-container-' + folderID;
      var folder = $(name);

      var ob = new OverlayBox($('#popup-folder-delete-template'), {});
      ob.setup();
      ob.load(function () {
        ob.show();
      });

      $('#btnAbortDeleteFolder').click(function (event) {
        event.preventDefault();
        ob.destroy();
      });

      $('#btnDeleteFolder').click(function (event) {
        event.preventDefault();
        $.ajax({
          method: 'DELETE',
          url: url,
          data: { id: folderID }
        })
          .success(function (data) {
            if (data === true) {
              if ($('#folder-container-root').data('folder-id') == folderID) {
                $('#main-listing').css('display', '');
                $('#folder-' + folderID).css('display', 'none');
              }
              folder.fadeTo(500, 0, function () {
                folder.css('display', 'none');
              });
            }
          })
          .always(function () {
            ob.destroy();
          });
      });
    };

    Logo.prototype.loadFolder = function (folderID) {
      var self = this;
      $.ajax({
        method: 'GET',
        url: serverSettings.currentPageURL + 'loadFolder?folderId=' + folderID,
        success: function (data) {
          if (folderID) {
            $('#folder-' + folderID).replaceWith(data);
            self.openFolder(folderID);
          } else {
            $('#main-listing').html(data);
            self.closeFolder();
          }
        }
      });
    };

    /**
     * @method downloadLogo
     * @deprecated
     */
    Logo.prototype.downloadLogo = function (logoID) {
      var _this = this;

      var ctaFuction = function () {
        $.ajax({
          url: '/data/download-logo.json',
          data: { id: logoID },
          success: function (data) {
            if (!data || !data.source) {
              toast.queueError(t('An error occured, please try again later.'));
              ab.show();
            } else {
              $('<iframe/>')
                .attr({
                  src: data.source,
                  style: 'visibility:hidden;display:none'
                })
                .appendTo('body');
            }
          },
          error: function () {
            toast.queueError(t('An error occured, please try again later.'));
          }
        });
      };
    };

    Logo.prototype.deleteLogo = function (logoID, apiDeleteURL) {
      var _this = this;

      var ctaDownload = function () {
        $.ajax({
          url: apiDeleteURL,
          data: { id: logoID },
          success: function (data) {
            $('.logo')
              .filter('[data-logo-id="' + logoID + '"]')
              .addClass('logo--disabled');
          },
          error: function () {
            toast.queueError(t('An error occured, please try again later.'));
          }
        });
      };

      var ab = new AlertBox(t('Are you sure that you what to delete logo?'));
      ab.addCTA(t('Delete'), ctaDownload, 'right', true);
      ab.addCTA(t('Cancel'), false, 'left');
      ab.show();
    };

    Logo.prototype.openLogo = function (logoID) {
      var logoImage = $('.logo[data-logo-id="' + logoID + '"]').data('logo-image');

      var magnifyImageBox = new MagnifyImageBox({
        isImage: true,
        src: logoImage
      });
      magnifyImageBox.show();
    };

    return new Logo();
  };
});

